import api from "./api";
import { APIS } from "../endpoints";

/**
 * Get all static pages data
 * @param {number} limit - Number of records per page
 * @param {number} page - Page number
 * @param {string} searchTerm - Optional search term
 * @returns {Promise<Object>} - Function returns static pages data
 */
export const getAllStaticPagesData = async (limit =50, page =1, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm);
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.staticPages}`, {
        params: params
    });

    return result ? result?.data : [];
};

/**
 * Get static page data by slug
 * @param {string} slug - The slug identifier (e.g., 'privacy-policy', 'about-us')
 * @returns {Promise<Object>} - Static page data
 */
export const getStaticPageData = async (slug) => {
    try {
        const result = await api.get(`${APIS.BASE_URL}${APIS.staticPages}/${slug}`);
        return result?.data || [];
    } catch (error) {
        console.error('Error fetching static page data:', error);
        return [];
    }
};

/**
 * Create new static page
 * @param {Object} data - Static page data
 * @returns {Promise<Object>} - Created static page
 */
export const createStaticPage = async (data) => {
    try {
        const result = await api.post(`${APIS.BASE_URL}${APIS.staticPages}`, data);
        if (result) {
            return result?.data;
        }
        return [];
    } catch (error) {
        console.error('Error creating static page:', error);
        throw error;
    }
};

/**
 * Update existing static page
 * @param {string} slug - The slug identifier
 * @param {Object} data - Updated static page data
 * @returns {Promise<Object>} - Updated static page
 */
export const updateStaticPageData = async (slug, data) => {
    try {
        const result = await api.put(`${APIS.BASE_URL}${APIS.staticPages}/${slug}`, data);
        if (result) {
            return result?.data;
        }
        return [];
    } catch (error) {
        console.error('Error updating static page:', error);
        throw error;
    }
};
